import _ from 'lodash'

export default ({ $supabase, $utils, $user, $analytics, $nuxtApi }, inject) => {
  const sharing = {
    async  addToCollabs (procedure, collabs, collectivite) {
      let toInsert = collabs.map(e => ({
        user_email: e.email,
        project_id: procedure.project_id,
        shared_by: $user.id,
        notified: false,
        role: 'write_frise',
        archived: false,
        dev_test: true
      }))

      const sender = {
        user_email: $user.email,
        project_id: procedure.project_id ?? procedure.secondary_procedure_of.project_id,
        shared_by: $user.id,
        notified: false,
        role: 'write_frise',
        archived: false,
        dev_test: true
      }

      toInsert = [...toInsert, sender]
      console.log('TO INSERT: ', toInsert)

      $analytics({
        category: 'partage',
        name: 'ajout collaborateur',
        value: 'write_frise'
      })

      const { error: errorInsertedCollabs } = await $supabase.from('projects_sharing').upsert(toInsert, { onConflict: 'project_id,user_email,role', ignoreDuplicates: true }).select()
      if (errorInsertedCollabs) { console.log('errorInsertedCollabs: ', errorInsertedCollabs) }

      let title = 'Invitation à collaborer sur Docurba'
      if ($user.profile.departement && $user.profile.side === 'etat') { title = `La DDT (M) du ${$user.profile.departement} vous invite à collaborer sur Docurba` }
      if (collectivite?.intitule && $user.profile.side === 'collectivite') { title = `La collectivité ${collectivite?.intitule} vous invite à collaborer sur Docurba` }
      await $nuxtApi.post('/api/slack/notify/frp_shared', {
        from: {
          email: $user.email,
          firstname: $user.profile.firstname,
          lastname: $user.profile.lastname,
          poste: `${$user.profile.poste ?? ''} ${$user.profile.other_poste ?? ''}`
        },
        to: {
          emailsFormatted: toInsert.map(e => e.user_email).reduce((acc, curr) => acc + ', ' + curr, '').slice(2),
          emails: toInsert.map(e => e.user_email)
        },
        type: 'frp',
        procedure: {
          id: procedure.id,
          project_id: procedure.project_id,
          url: `/frise/${procedure.id}`,
          name: $utils.formatProcedureName(procedure, collectivite)
        },
        title
      })
    },
    async getSuggestedCollaborators (collectivite) {
      const {
        data: stateProfiles,
        error: errorCollaborators
      } = await $supabase.from('profiles').select('*').eq('departement', collectivite.departementCode).eq('side', 'etat').neq('email', $user.email)

      const { data: collectiviteProfiles, error: errorCollectiviteProfiles } = await $supabase.from('profiles').select('*')
        .eq('side', 'collectivite')
        .or(`collectivite_id.eq.${collectivite.code}, collectivite_id.eq.${collectivite.intercommunaliteCode}`)
      if (errorCollectiviteProfiles) { console.log('errorCollectiviteProfiles: ', errorCollectiviteProfiles) }

      let collaborators = [...stateProfiles, ...collectiviteProfiles].map(e => $utils.formatProfileToCreator(e))
      if (errorCollaborators) { throw errorCollaborators }

      collaborators = this.excludeStaff(collaborators)
      return collaborators
    },
    async  getCollaborators (procedure, collectivite) {
      let legacyCollabs = []
      if (!procedure.shareable) {
        console.log('IS NOT SHAREABLE')
        const adminDept = _.uniq(procedure.procedures_perimetres.map(p => p.departement))
        const { data: stateProfiles, error: errorStateProfiles } = await $supabase.from('profiles').select('*')
          .in('departement', adminDept)
          .eq('side', 'etat')
          .is('verified', true)

        if (errorStateProfiles) { console.log('errorStateProfiles: ', errorStateProfiles) }

        const { data: collectiviteProfiles, error: errorCollectiviteProfiles } = await $supabase.from('profiles').select('*')
          .eq('side', 'collectivite')
          .or(`collectivite_id.eq.${collectivite.code}, collectivite_id.eq.${collectivite.intercommunaliteCode}`)
        if (errorCollectiviteProfiles) { console.log('errorCollectiviteProfiles: ', errorCollectiviteProfiles) }

        legacyCollabs = [...stateProfiles ?? [], ...collectiviteProfiles ?? []].map(e => ({ ...e, legacy_sudocu: true }))
      }

      const { data: collabsData, error: errorCollabs } = await $supabase.from('projects_sharing')
        .select('*')
        .eq('project_id', procedure.project_id)
        .eq('role', 'write_frise')
        .order('created_at', { ascending: false })

      if (errorCollabs) { console.log('errorCollabs: ', errorCollabs) }
      console.log('collabsData: ', collabsData, ' procedure.project_id: ', procedure.project_id)
      const emails = _.uniq(collabsData.flatMap(
        d => d.user_email
          ? d.user_email.split(';').map(e => e.replaceAll('"', '').trim().toLowerCase())
          : []
      ))

      const { data: profilesData, error: errorProfiles } = await $supabase.from('profiles').select('*').ilikeAnyOf('email', emails)
      if (errorCollabs) { console.log('errorProfiles: ', errorProfiles) }
      const allCollaborators = [...profilesData ?? [], ...legacyCollabs ?? []]
      const formattedProfiles = allCollaborators.map((e) => {
        if (e.user_id === procedure.owner_id) {
          e.initiator = true
        }
        return $utils.formatProfileToCreator(e)
      })

      const profilesEmails = profilesData.map(profile => profile.email && profile.email.toLowerCase())
      const noProfilesCollabs = emails.filter(e => !!e && !profilesEmails.includes(e.toLowerCase()))
        .map(e => ($utils.formatProfileToCreator({ email: e })))
      const finalCollabs = [...noProfilesCollabs, ...formattedProfiles]
      const uniqFinalCollabs = _.uniqBy(finalCollabs, e => e.email)
      return uniqFinalCollabs
    },
    excludeStaff (collabs) {
      return collabs.filter((collab) => {
        return !(collab.profile?.is_admin || collab.profile?.is_staff)
      })
    }
  }
  inject('sharing', sharing)
}
